import {Component, Input} from "@angular/core";
import {StageService} from "../../services/conditionService";
import {STUFF_CATEGORIES_LIST} from "../../enums/e-stuff-categories";
import {VALUE_TYPE} from "../../enums/enums";
import {CONDITION_TYPES, CONDITION_TYPES_LIST} from "../../enums/e-conditions";
import {GO_CATEGORIES_LIST} from "../../enums/e-game-objects";
import {UI_TEXTS} from "../../enums/e-texts";
import {ICondition, IContainsCondition} from "../../interfaces/condition.definition";
import {IEnumListEntry} from "../../definitions";


@Component({
  selector: "nv-condition",
  templateUrl: "./nv-condition.component.html"
})


export class NvConditionComponent {
  UI_TEXTS = UI_TEXTS;
  CONDITION_TYPES_LIST = CONDITION_TYPES_LIST.sort(this.sortConditions);
  CONDITION_TYPES = CONDITION_TYPES;
  STUFF_CATEGORIES_LIST = STUFF_CATEGORIES_LIST;
  GO_CATEGORIES_LIST = GO_CATEGORIES_LIST;
  VAL_TYPES = VALUE_TYPE;

  _condition: ICondition;

  /* There are two possible ways for setting condition !!! */
  @Input() set document(v: IContainsCondition) {
    this._condition = v.condition;
  };

  @Input() set condition(v: ICondition) {
    this._condition = v;
  }

  get condition(): ICondition {
    return this._condition;
  }

  get params(): any {
    return this.condition.params;
  }


  constructor(private _stageService: StageService) {
  }


  onConditionTypeChange() {
    this._stageService.initializeConditionParams(this.condition);
  }

  private sortConditions(cA:IEnumListEntry, cB:IEnumListEntry)
  {
    if (cA.label > cB.label)
    {
      return 1;
    }
    else if (cA.label < cB.label)
    {
      return -1;
    }
    else
    {
      return 0;
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-condition/nv-condition.component.ts